import { render, staticRenderFns } from "./VDemoForm.vue?vue&type=template&id=2f2e3058&scoped=true&"
import script from "./VDemoForm.vue?vue&type=script&lang=js&"
export * from "./VDemoForm.vue?vue&type=script&lang=js&"
import style0 from "./VDemoForm.vue?vue&type=style&index=0&id=2f2e3058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e3058",
  null
  
)

export default component.exports